import { get } from "../../utils/httpClient";

const taxReturnService = () => {
  const prefixApi = "duedates/taxreturns";

  const getTaxYears = async () => {
    return await get(`/${prefixApi}/taxyears`);
  };

  return {
    getTaxYears,
  };
};

export default taxReturnService;
